import { faqs } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">常见问答</h2>
            <p className="mt-2 text-sm text-foreground-500">关于韩漫网你想知道的一切</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6">
                <h3 className="text-base font-semibold text-foreground-900 mb-2 flex items-start gap-3">
                  <span className="text-primary-500 font-bold flex-shrink-0">Q{i + 1}</span>
                  {faq.q}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}